import React from "react";

import { IProductTemplateAttribute } from "components/dashboard/product-template-table/utils/interfaces";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { Tooltip } from "react-tooltip";
import { T } from "services/lang/LanguageService";

type DatetimeAndInstantTypesProps = {
  attribute: IProductTemplateAttribute;
  onAttrChangeInDatetimeAndInstant: React.Dispatch<React.SetStateAction<IProductTemplateAttribute>>;
};

const DatetimeAndInstantTypes: React.FC<DatetimeAndInstantTypesProps> = ({
  attribute,
  onAttrChangeInDatetimeAndInstant,
}) => {
  const onFieldChange = (e: React.ChangeEvent<HTMLInputElement> | InputSwitchChangeEvent) =>
    onAttrChangeInDatetimeAndInstant(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

  return (
    <>
      <div className="p-field p-col-6">
        <label>{T("word.date-display-pattern")}</label>
        <InputText
          placeholder="e.g.: yyyy-MM-dd"
          value={attribute.dateDisplayPattern}
          name="dateDisplayPattern"
          onChange={onFieldChange}
          className="p-inputtext-sm"
        />
      </div>
      <div className="flex-1 flex w-full align-self-center justify-content-center gap-3">
        <Tooltip id="autoFillTime-tooltip" />
        <label
          htmlFor="autoFillTime"
          data-tooltip-id="autoFillTime-tooltip"
          data-tooltip-content={T("word.auto-fill-time-content")}
        >
          {T("word.auto-fill-time")}
        </label>
        <InputSwitch
          id="autoFillTime"
          checked={attribute.autoFillTime ?? false}
          name="autoFillTime"
          onChange={onFieldChange}
          className="p-inputtext-sm"
        />
      </div>
    </>
  );
};

export default DatetimeAndInstantTypes;
